<template>
  <div v-if="init" id="mainContainer">
    <!--ページヘッダー-->
    <header class="tit" id="pageHeader">
      <h1 class="h1_tit"><img src="/assets/images/program/h1_program.png" alt="番組表"></h1>
      <h2 class="h2_tit">{{ display_dates_text }}</h2>
    </header>
    <nav id="timeNavi">
      <ul class="navi_list">
        <li class="morning"><a href="#morning">朝</a></li>
        <li class="noon"><a href="#noon">昼</a></li>
        <li class="night"><a href="#night">夜</a></li>
        <li class="midnight"><a href="#midnight">深夜</a></li>
      </ul>
    </nav>
    <div v-if="emergency" id="notice">
      <div class="notice_inner" v-html="emergency"></div>
    </div>
    <div class="border_wrap" id="container">
      <div class="border_r">
        <div class="border_l">
          <div class="border_inner" id="timetable">
            <section>
              <table class="timetable">
                <tbody>
                  <tr class="week isPC">
                    <th class="nav prev" scope="col"></th>
                    <th v-for="(header, i) in headers" :key="i" :colspan="(i === 3 && header_colspans[display_date]) ? 2 : 1" :class="{ sat: header.is_sat, sun: header.is_sun, holiday: header.is_holiday, on: header.display_date === display_date }">
                      <p class="btn" @click="display_date = header.display_date">
                        <sup v-if="header.month" class="month">{{ header.month }}/</sup>
                        <span class="date">{{ header.date }}</span>
                        <sub class="week">（{{ header.week }}）</sub>
                      </p>
                    </th>
                  </tr>
                  <tr class="week isSP">
                    <th class="nav prev" scope="col">
                      <span v-if="display_date === display_dates[0]" class="off">前の日へ</span>
                      <a v-else class="button" @click="goPrevDay">前の日へ</a>
                    </th>
                    <th scope="col" colspan="7">
                      <div class="btn">
                        <select class="select_day" v-model="display_date">
                          <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
                        </select>
                      </div>
                    </th>
                    <th class="nav next" scope="col">
                      <span v-if="display_date === display_dates[6]" class="off">次の日へ</span>
                      <a v-else class="button" @click="goNextDay">次の日へ</a>
                    </th>
                  </tr>
                  <tr v-for="(program, i) in sv1_programs[display_date]" :key="i" :class="program.zone" :id="program.zone">
                    <td class="time">
                      <time>{{ program.time }}</time>
                    </td>
                    <td class="prog" :colspan="program.colspan">
                      <dl>
                        <dt class="tit">{{ program.title }}<span v-for="(icon, i) in program.icons" :key="i" :class="icon.class">{{ icon.text }}</span></dt>
                        <dd class="info">{{ program.subtitle }}</dd>
                        <dd class="info">{{ program.cast }}</dd>
                      </dl>
                      <p v-if="program.link" class="btn"><a :href="program.link">番組ページ</a></p>
                    </td>
                    <td v-if="sv2_programs[program.start]" class="prog channel2" colspan="4" :rowspan="sv2_programs[program.start].rowspan">
                      <p class="tletama2">テレ玉２<span class="num">(032)</span></p>
                      <div v-for="(program, i) in sv2_programs[program.start].programs" :key="i" class="prog is_btn">
                        <time>{{ program.time }}</time>
                        <dl>
                          <dt class="tit">{{ program.title }}<span v-for="(icon, i) in program.icons" :key="i" :class="icon.class">{{ icon.text }}</span></dt>
                          <dd class="info">{{ program.subtitle }}</dd>
                          <dd class="info">{{ program.cast }}</dd>
                        </dl>
                        <p v-if="program.link" class="btn"><a :href="program.link">番組ページ</a></p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </div>
      <div id="legend">
        <div class="legend_inner">
          <ul class="legend_list">
            <li> <span class="icon">再</span><span class="desc">再放送</span></li>
            <li> <span class="icon">終</span><span class="desc">最終回</span></li>
            <li> <span class="icon">新</span><span class="desc">新番組</span></li>
            <li> <span class="icon">字</span><span class="desc">字幕</span></li>
            <li> <span class="icon">手</span><span class="desc">手話</span></li>
            <li> <span class="icon">SS</span><span class="desc">サラウンドステレオ</span></li>
            <li> <span class="icon">多</span><span class="desc">音声多重</span></li>
            <li> <span class="icon">解</span><span class="desc">解説放送</span></li>
            <li> <span class="icon">ニ</span><span class="desc">二カ国語</span></li>
            <li> <span class="icon">デ</span><span class="desc">番組連動データ放送</span></li>
            <li> <span class="icon free">見</span><span class="desc">見逃し配信（他社サイト）</span></li>
            <li> <span class="icon free">TOD</span><span class="desc">テレ玉オンデマンド</span></li>
            <li> <span class="icon free">TODF</span><span class="desc">テレ玉オンデマンドFREE</span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      sv1_programs: {},
      sv2_programs: {},
      inserts: {},
      holidays: [],
      display_date: null,
      init: false
    }
  },
  computed: {
    columns () {
      return ['date', 'title', 'subtitle', 'cast', 'link', 'icon1', 'icon2', 'icon3', 'icon4', 'icon5', 'icon6', 'icon7', 'icon8', 'icon9', 'icon10', 'icon11']
    },
    display_dates () {
      return Object.keys(this.sv1_programs).slice(0, 7)
    },
    display_dates_text () {
      return moment(this.display_dates[0]).format('M/D（dddd）〜') + moment(this.display_dates[6]).format('M/D（dddd）')
    },
    headers () {
      return this.display_dates.map((display_date, i) => {
        const d = moment(display_date)
        return {
          display_date: display_date,
          month: i === 0 || d.date() === 1 ? d.format('M') : null,
          date: d.format('D'),
          week: d.format('dddd'),
          is_sat: d.day() === 6,
          is_sun: d.day() === 0,
          is_holiday: this.holidays.indexOf(display_date) !== -1
        }
      })
    },
    header_colspans () {
      // マルチ編成がある日とない日でthのcolspanの値を変更する必要あり
      const colspans = {}
      Object.keys(this.sv2_programs).some(date => {
        colspans[moment(date).format('YYYY-MM-DD')] = true
      })
      return colspans
    },
    options () {
      return this.display_dates.map(display_date => {
        return {
          label: moment(display_date).format('YYYY/M/D（dddd）'),
          value: display_date
        }
      })
    }
  },
  async created () {
    // 曜日を日本語化
    moment.updateLocale('en', { weekdays : ['日', '月', '火', '水', '木', '金', '土'] })
    // 差し込みデータの取得
    const inserts = await axios.get('/assets/program-table/program-table-insert.json')
    inserts.data = inserts.data || []
    inserts.data.forEach(program => {
      // 差し込むch,日時をキーにして格納
      this.inserts[`${program['target-ch']} ${program['date']}`] = program
    })
    // 番組表データ（SV2）の取得
    const sv2_programs = await this.getPrograms('/bangumi_data/sv2.csv', 'sv2')
    let temp_start, temp_end
    sv2_programs.forEach(program => {
      // マルチ編成の開始時間をキーにして、マルチ編成ごとに分類して格納
      if (program.start !== temp_end) {
        this.sv2_programs[program.start] = { start:program.start, end: program.end, programs: [program], rowspan: 0 }
        temp_start = program.start
        temp_end = program.end
      } else {
        this.sv2_programs[temp_start].programs.push(program)
        this.sv2_programs[temp_start].end = program.end
        temp_end = program.end
      }
    })
    // 番組表データ（SV1）の取得
    const sv1_programs = await this.getPrograms('/bangumi_data/sv1.csv', 'sv1')
    sv1_programs.forEach(program => {
      // 開始時間がマルチ編成かどうか確認
      const sv2 = Object.keys(this.sv2_programs).map(key => this.sv2_programs[key]).find(sv2 => {
        return moment(program.start).isBetween(sv2.start, sv2.end, null, '[)')
      })
      if (sv2) {
        program.colspan = 4
        sv2.rowspan += 1
      }
      // 日をキーにして、日毎に分類して格納
      this.sv1_programs[program.date] = this.sv1_programs[program.date] || []
      this.sv1_programs[program.date].push(program)
    })
    // 祝日データの取得
    const holidays = await axios.get('/assets/program-table/holidays.json')
    this.holidays = holidays.data || []
    // 緊急のお知らせを取得
    const emergency = await axios.get('/assets/program-table/emergency.json')
    this.emergency = emergency && emergency.data && emergency.data.length && emergency.data[0].emergency
    // 最初に表示する日付
    this.display_date = Object.keys(this.sv1_programs)[0]
    // 初期化を完了
    this.init = true
    // DOMのレンダリング後にjQuery系のメソッドを呼ぶ必要あり
    this.$nextTick(window.teletama.pageScroll)
  },
  methods: {
    async getPrograms (url, ch) {
      const csv = await axios.get(url)
      const programs = csv.data ? this.parse(csv.data) : []
      return programs.map(program => {
        const date = program.date
        // 日時のフォーマットを変換
        program.date = date.slice(0, 10).replace(/\//g, '-') + ' ' + date.slice(14, 19) + ':00'
        program.end = date.slice(0, 10).replace(/\//g, '-') + ' ' + date.slice(20, 25) + ':00'
        // 差し込みデータの存在確認
        const insert = this.inserts[`${ch} ${program.date}`]
        // 差し込みデータがあり、かつ非表示に設定されている場合は後続処理をスキップ
        if (insert && insert.hidden) return
        // 差し込みデータがある場合でも、終了時間は番組表から取得する
        if (insert) insert.end = program.end
        // 番組データ
        return this.getProgram(insert || program)
      })
    },
    parse (data) {
      return CSV.parse(data).map(data => {
        const object = {}
        data.forEach((d, i) => {
          object[this.columns[i]] = d
        })
        return object
      })
    },
    getProgram (data) {
      const d = moment(data.date)
      let date = d.format('YYYY-MM-DD')
      let time = d.format('HH:mm')
      if (time < '04:00') {
        date = d.add(-1, 'days').format('YYYY-MM-DD')
        time = 24 + d.hour() + d.format(':mm')
      }
      const program = {
        date: date,
        time: time,
        start: data.date,
        end: data.end,
        zone: this.getZone(time),
        title: data.title,
        subtitle: data.subtitle,
        cast: data.cast,
        link: data.link,
        icons: [],
        colspan: 8
      }
      if (data.icon1) program.icons.push({ text: '再', class: 'icon' })
      if (data.icon2) program.icons.push({ text: '終', class: 'icon' })
      if (data.icon3) program.icons.push({ text: '新', class: 'icon' })
      if (data.icon4) program.icons.push({ text: '字', class: 'icon' })
      if (data.icon5) program.icons.push({ text: '手', class: 'icon' })
      if (data.icon6) program.icons.push({ text: 'SS', class: 'icon' })
      if (data.icon7) program.icons.push({ text: '多', class: 'icon' })
      if (data.icon8) program.icons.push({ text: '解', class: 'icon' })
      if (data.icon9) program.icons.push({ text: '二', class: 'icon' })
      if (data.icon10) program.icons.push({ text: 'デ', class: 'icon' })
      if (data.icon11) program.icons.push({ text: data.icon11, class: 'icon free' })
      return program
    },
    getZone (time) {
      if (time < '10:00') return 'morning'
      if (time < '18:00') return 'noon'
      if (time < '24:00') return 'night'
      return 'midnight'
    },
    goPrevDay () {
      this.display_date = moment(this.display_date).add(-1, 'days').format('YYYY-MM-DD')
    },
    goNextDay () {
      this.display_date = moment(this.display_date).add(1, 'days').format('YYYY-MM-DD')
    }
  }
}
</script>
